import { render, staticRenderFns } from "./block-organizations-delete.vue?vue&type=template&id=5345e954&scoped=true&lang=pug"
import script from "./block-organizations-delete.vue?vue&type=script&lang=js"
export * from "./block-organizations-delete.vue?vue&type=script&lang=js"
import style0 from "./block-organizations-delete.vue?vue&type=style&index=0&id=5345e954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345e954",
  null
  
)

export default component.exports